/**
 * @generated SignedSource<<9fda661474966196acf2b180310ea6ee>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SharedYMAL_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SharedRelatedItemsSection_user">;
  readonly " $fragmentType": "SharedYMAL_user";
};
export type SharedYMAL_user$key = {
  readonly " $data"?: SharedYMAL_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"SharedYMAL_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SharedYMAL_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedRelatedItemsSection_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "a121ee4df2f0679586fcaf9ebd60ce6d";

export default node;
